export const SpaceGeometryTypePoint = 'Point';
